'use client';
import gsap from 'gsap';
import Lenis from 'lenis';
import { useEffect } from 'react';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import { setLenisInstance } from 'shared/lenis';

export const LenisProvider = ({ children }) => {
  useEffect(() => {
    // Сделано, чтобы была возможность помечать для Lenis скролл-элементы которые не нужно перехватывать
    const lenis = new Lenis({
      lerp: 0.12,
      syncTouch: true,
      prevent: node => node.closest('[data-lenis-prevent]') !== null,
    });

    setLenisInstance(lenis);
    lenis.on('scroll', ScrollTrigger.update);

    const rafCallback = time => {
      lenis.raf(time * 1000);
    };

    gsap.ticker.add(rafCallback);
    gsap.ticker.lagSmoothing(0);

    return () => {
      gsap.ticker.remove(rafCallback);
      lenis.destroy();
      setLenisInstance(null);
    };
  }, []);

  return children;
};
